import { render, staticRenderFns } from "./PosInvoiceCreate.vue?vue&type=template&id=03246861&scoped=true"
import script from "./PosInvoiceCreate.vue?vue&type=script&lang=js"
export * from "./PosInvoiceCreate.vue?vue&type=script&lang=js"
import style0 from "./PosInvoiceCreate.vue?vue&type=style&index=0&id=03246861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03246861",
  null
  
)

export default component.exports